// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".project-info__branch-selector[data-v-7b75fec4]{min-width:100%}@media screen and (min-width:768px){.project-info__branch-selector[data-v-7b75fec4]{min-width:auto}.project-info__branch-selector .select-branch[data-v-7b75fec4]{min-width:140px}}.project-info__branch-selector .select-branch__loader[data-v-7b75fec4]{text-align:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
